import React from "react";
import { Loader2 } from "lucide-react";

interface SpinnerProps {
  size?: number;
  className?: string;
}

export function Spinner({ size = 32, className = "" }: SpinnerProps) {
  return (
    <Loader2
      className={`animate-spin text-primary-600 ${className}`}
      style={{ width: size, height: size }}
    />
  );
}
